import {
    CREAR_PACIENTE,
    CREAR_PACIENTE_EXITO,
    CREAR_PACIENTE_ERROR,
    CREAR_USUARIO_PACIENTE,
    CREAR_USUARIO_PACIENTE_ERROR,
    CREAR_USUARIO_PACIENTE_EXITO
} from '../types';
import { cargarPacientesAction } from './cargarPacientesActions';
import clienteAxios from '../config/axios';

export function crearPacienteAction(informacion) {

    return async (dispatch) => {

        dispatch(crearPaciente());

        try {

            const {
                config,
                payload
            } = informacion;


            const respuesta =
                await clienteAxios.post(
                    '/paciente/crearpacienteadministrativo',
                    payload,
                    config
                );


            dispatch(
                crearPacienteExito(
                    respuesta.data.msg
                )
            );


            dispatch(
                cargarPacientesAction(informacion)
            );


            return {
                ok: true,
                msg: respuesta.data.msg
            };


        } catch (error) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudo crear el paciente'
                };


            dispatch(
                crearPacienteError(mensaje)
            );


            return {
                ok: false,
                error: mensaje
            };
        }
    };
}

const crearPaciente = () => ({
    type: CREAR_PACIENTE,
    payload: true
});
const crearPacienteExito = (msg) => ({
    type: CREAR_PACIENTE_EXITO,
    payload: msg
});
const crearPacienteError = (msg) => ({
    type: CREAR_PACIENTE_ERROR,
    payload: msg
});

export function crearUsuarioPacienteAction(
    informacion
) {

    return async dispatch => {

        dispatch(
            crearUsuarioPaciente()
        );


        try {

            const {
                payload
            } = informacion;


            const respuesta =
                await clienteAxios.post(
                    '/paciente/crearusuariopaciente',
                    payload
                );


            dispatch(
                crearUsuarioPacienteExito(
                    respuesta.data.msg
                )
            );


            return {

                ok:
                    true,

                data:
                    respuesta.data

            };


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudo crear el usuario del paciente'
                };


            dispatch(
                crearUsuarioPacienteError(
                    mensaje
                )
            );


            return {

                ok:
                    false,

                error:
                    mensaje

            };

        }

    };

}

const crearUsuarioPaciente = () => ({
    type: CREAR_USUARIO_PACIENTE,
    payload: true
});
const crearUsuarioPacienteExito = (msg) => ({
    type: CREAR_USUARIO_PACIENTE_EXITO,
    payload: msg
});
const crearUsuarioPacienteError = (msg) => ({
    type: CREAR_USUARIO_PACIENTE_ERROR,
    payload: msg
});